import { selectChangeMessageForPreviousVersionItems } from '@UI/aside/asidePreviousVersionItems/AsidePreviousVersionItemsSelectors';
import { ContentType } from '@generalTypes/apiTypes';
import { selectGoalSubItem } from '@newStore/documentUI/transformContent/llinkidSelectors';
import type { BuildingBlockNodeConfig } from '@nodeTypeConfig/configTypes';
import { llinkidDescriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';

const LLINKID_GOAL_EXPLANATION: BuildingBlockNodeConfig = {
  nodeSelector: selectGoalSubItem,
  information: {
    single: 'Duiding',
    plural: 'Duidingen',
  },

  edit: [
    llinkidDescriptionComponent,
    {
      component: 'previousVersionItems',
      reactComponent: 'AsidePreviousVersionItems',
      label: 'Vervangt (uit vorige versie)',
      options: {
        relationTypes: ['REPLACES'],
        modal: 'llinkidPreviousVersionModal',
        modalTitle: 'Vervangt (uit vorige versie)',
        listColumn: 'description',
        placeholder: 'Kies een te vervangen duiding',
        relation: 'Duiding',
        errorMessage: 'Je moet een geldige duiding selecteren',
        type: ContentType.LLINKID_GOAL_EXPLANATION,
      },
      asideChangeMessageSelector: selectChangeMessageForPreviousVersionItems,
    },
  ],
  buildingBlocks: [],
  isCollapsible: false,
  onNewNodeDropped: {
    focusOnField: 'description',
  },
};

export default LLINKID_GOAL_EXPLANATION;
